export default __webpack_public_path__ + "static/media/servicing_image.516e4f70.png";